import React from 'react';
import { CustomPicker } from 'react-color';
import { Saturation } from 'react-color/lib/components/common';
import InputFields from './components/input-fields';
import Pointer from './components/pointer';
import ColorPattern from './components/color-pattern';
import Stack from '../stack';
import NotificationMessage from '../notification-message';
import Paragraph from '../paragraph';

/*
 * Saturation expects the pointer prop to be a component that only accepts
 * { direction?: "vertical" }, but Pointer expects a { hex: string } prop.
 * This is a known issue with @types/react-color and
 * cannot be fixed without ignoring the type check here.
 */

const ColorPicker = ({
  notificationTitle = '',
  enableAlpha = false,
  alphaTooltipLabel = '',
  preventInputOverflow = false,
  ...props
}) => (
  <div className="ws-ui-color-picker">
    <Stack gap="spacing-s">
      <div className="ws-ui-color-picker__saturation">
        <Saturation
          {...props}
          // eslint-disable-next-line yola/@typescript-eslint/ban-ts-comment
          /* @ts-ignore TS(2769): @types/react-color pointer typing is wrong */
          pointer={Pointer}
        />
      </div>
      <Stack gap="spacing-xs">
        <ColorPattern {...props} enableAlpha={enableAlpha} />
        <Stack gap="spacing-xs">
          <InputFields
            {...props}
            enableAlpha={enableAlpha}
            alphaTooltipLabel={alphaTooltipLabel}
            preventOverflow={preventInputOverflow}
          />
          {notificationTitle && (
            <NotificationMessage
              appearance="warning"
              iconGlyph="bell"
              title={<Paragraph>{notificationTitle}</Paragraph>}
            />
          )}
        </Stack>
      </Stack>
    </Stack>
  </div>
);

export default CustomPicker(ColorPicker);
